<div>
  <div class="card p-6">
    <app-steps-v2 class="block" [steps]="steps()" />
  </div>
  <div class="flex flex-col md:flex-row gap-4 mt-4">
    <div class="px-8 py-4 user-card flex flex-col gap-4 rounded-[0.25rem] flex-1">
      <div class="flex flex-col items-center">
        <span class="text-[1.625rem]/[160%] font-bold text-[#505760]">
          {{ 'my-forest.sproutedSeeds' | translate }}
        </span>
        <span class="text-[1.125rem]/[160%] text-[#737980]">{{ 'my-forest.acceptedInvitations' | translate }}</span>
      </div>
      <div class="flex flex-col gap-6 items-center">
        <!-- chart -->
        @if (donutDataLoaded()) {
          <div class="relative">
            <apx-chart
              #chart
              [series]="donutChartOptions().series"
              [chart]="donutChartOptions().chart"
              [colors]="donutChartOptions().colors"
              [plotOptions]="donutChartOptions().plotOptions"
              [dataLabels]="donutChartOptions().dataLabels"
              [fill]="donutChartOptions().fill"
              [stroke]="donutChartOptions().stroke"
              [legend]="donutChartOptions().legend"
              [labels]="donutChartOptions().labels"
              [tooltip]="donutChartOptions().tooltip"
              [states]="donutChartOptions().states"
            ></apx-chart>
            <div class="absolute w-full h-full top-0 left-0 flex items-center justify-center pointer-events-none">
              <div class="flex flex-col items-center gap-[0.16rem]">
                <div class="text-[1.9375rem]/[140%] text-[#2C3035] font-bold">{{ totalCount() }}</div>
                <div class="text-[1.125rem]/[160%] text-[#737980]">{{ 'my-forest.invitations' | translate }}</div>
              </div>
            </div>
          </div>
        }
        <div class="flex gap-4 items-center">
          <div class="flex gap-1 items-center">
            <div class="rounded-[0.125rem] bg-[#007DCB] size-[0.875rem]"></div>
            <span class="text-[0.9375rem]/[160%] text-[#505760]">{{ 'my-forest.accepted' | translate }}</span>
          </div>
          <div class="flex gap-1 items-center">
            <div class="rounded-[0.125rem] bg-[#8AC3E7] size-[0.875rem]"></div>
            <span class="text-[0.9375rem]/[160%] text-[#505760]">{{ 'my-forest.pending' | translate }}</span>
          </div>
        </div>
      </div>
      <div class="flex gap-1 items-center w-full justify-center">
        <span class="text-[1.125rem]/[160%] text-[#505760]">
          {{ 'my-forest.inTheLastMonth' | translate: { count: lastMonthDonut() } }}
        </span>
        @if (isDonutGrowing()) {
          <i>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <path
                d="M13.7489 6L21.3027 6.00052L21.403 6.01444L21.5018 6.04205L21.5621 6.0676C21.6413 6.10246 21.7155 6.15315 21.7808 6.21836L21.8215 6.2624L21.865 6.31878L21.9192 6.4089L21.9579 6.49922L21.977 6.5633L21.9906 6.6273L22 6.7215L22.0004 14.2539C22.0004 14.6681 21.6647 15.0039 21.2504 15.0039C20.8708 15.0039 20.557 14.7217 20.5073 14.3557L20.5004 14.2539L20.5 8.559L12.7812 16.2793C12.5149 16.5455 12.0982 16.5698 11.8046 16.3519L11.7205 16.2793L8.75001 13.3089L3.28033 18.7786C2.98744 19.0715 2.51256 19.0715 2.21967 18.7786C1.9534 18.5123 1.9292 18.0957 2.14705 17.8021L2.21967 17.7179L8.21967 11.7179C8.48593 11.4517 8.90259 11.4275 9.1962 11.6453L9.28032 11.7179L12.2508 14.6883L19.438 7.5H13.7489C13.3692 7.5 13.0554 7.21785 13.0058 6.85177L12.9989 6.75C12.9989 6.3703 13.2811 6.05651 13.6472 6.00685L13.7489 6Z"
                fill="#078339"
              />
            </svg>
          </i>
        } @else {
          <i>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <path
                d="M13.7489 19.0002L21.3027 18.9997L21.403 18.9858L21.5018 18.9582L21.5621 18.9326C21.6413 18.8978 21.7155 18.8471 21.7808 18.7819L21.8215 18.7378L21.865 18.6814L21.9192 18.5913L21.9579 18.501L21.977 18.4369L21.9906 18.3729L22 18.2787L22.0004 10.7463C22.0004 10.3321 21.6647 9.99633 21.2504 9.99633C20.8708 9.99633 20.557 10.2785 20.5073 10.6446L20.5004 10.7463L20.5 16.4412L12.7812 8.72096C12.5149 8.45469 12.0982 8.43047 11.8046 8.64832L11.7205 8.72094L8.75001 11.6913L3.28033 6.22162C2.98744 5.92873 2.51256 5.92873 2.21967 6.22162C1.9534 6.48789 1.9292 6.90455 2.14705 7.19816L2.21967 7.28228L8.21967 13.2823C8.48593 13.5485 8.90259 13.5728 9.1962 13.3549L9.28032 13.2823L12.2508 10.3119L19.438 17.5002H13.7489C13.3692 17.5002 13.0554 17.7824 13.0058 18.1485L12.9989 18.2502C12.9989 18.6299 13.2811 18.9437 13.6472 18.9934L13.7489 19.0002Z"
                fill="#CB2222"
              />
            </svg>
          </i>
        }
      </div>
    </div>
    <div class="flex flex-col gap-4 flex-1">
      <!-- card -->
      <div class="px-8 py-6 flex flex-col gap-4 rounded-lg user-card flex-1" data-earnings="monthly">
        <div class="w-full flex justify-center">
          <div class="flex items-center justify-center size-10 rounded-lg bg-[#E6F2FA]">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M20.2499 2.00391C21.2163 2.00391 21.9998 2.78791 21.9998 3.755V6.79962C21.9998 7.82442 21.4307 8.76432 20.5229 9.23874L14.2413 12.5212C15.8772 13.3434 16.9999 15.0379 16.9999 16.9947C16.9999 19.7578 14.7614 21.9978 12 21.9978C9.23867 21.9978 7.00014 19.7578 7.00014 16.9947C7.00014 15.0379 8.12282 13.3434 9.75883 12.5212L3.47714 9.23874C2.56936 8.76432 2.00024 7.82442 2.00024 6.79962V3.755C2.00024 2.78791 2.78373 2.00391 3.75021 2.00391H20.2499ZM12 13.4925C10.0671 13.4925 8.50011 15.0605 8.50011 16.9947C8.50011 18.9289 10.0671 20.4969 12 20.4969C13.933 20.4969 15.5 18.9289 15.5 16.9947C15.5 15.0605 13.933 13.4925 12 13.4925ZM15.5 3.50385H8.50011V10.17L11.8843 11.939C11.9568 11.9769 12.0432 11.9769 12.1157 11.939L15.5 10.169V3.50385ZM7.00014 3.50385L3.75021 3.50485C3.61214 3.50485 3.50021 3.61685 3.50021 3.755V6.79962C3.50021 7.26544 3.7589 7.69267 4.17153 7.90832L7.00014 9.38553V3.50385ZM20.2499 3.50485L16.9999 3.50385V9.38553L19.8286 7.90832C20.2412 7.69267 20.4999 7.26544 20.4999 6.79962V3.755C20.4999 3.61685 20.388 3.50485 20.2499 3.50485Z"
                fill="#007DCB"
              />
            </svg>
          </div>
        </div>
        <div class="flex flex-col items-center gap-1">
          <span class="text-[#505760] text-[1.125rem]/[160%]">{{ 'my-forest.monthlyEarningsRecord' | translate }}</span>
          @if (isCommissionUser() && monthlyCommissionResource.status() === 'error') {
            <app-resource-load-error
              message="profile.monthlyEarningsLoadError"
              (retry)="monthlyCommissionResource.reload()"
            />
          } @else if (isCommissionUser()) {
            <span
              class="text-[#2C3035] text-[1.9375rem]/[160%] font-bold"
              [attr.aria-busy]="monthlyCommissionResource.isLoading()"
              >{{ monthlyCommissionDisplay() }}{{ monthlyCommissionResource.hasValue() ? ' USD' : '' }}</span
            >
          } @else {
            <span class="text-[#2C3035] text-[1.9375rem]/[160%] font-bold"
              >{{ user()?.monthlyEarnings | thousandsSeparator }} Ganas</span
            >
          }
          @if (monthlyEarningsRecordDate(); as recordDate) {
            <span class="text-[#505760] text-[1.125rem]/[160%]">{{
              recordDate | date: 'MMMM yyyy' : undefined : currentLanguage | titlecase
            }}</span>
          }
        </div>
      </div>
      <!-- card -->
      <div class="px-8 py-6 flex flex-col gap-4 rounded-lg user-card flex-1" data-earnings="lifetime">
        <div class="w-full flex justify-center">
          <div class="flex items-center justify-center size-10 rounded-lg bg-[#E6F2FA]">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M16.1523 2.16359C16.5461 2.03602 16.9687 2.25229 17.0966 2.64601C17.3577 3.44994 17.3716 4.34626 17.2509 5.19582C22.345 6.58658 21.4011 13.6003 20.123 15.7603C18.0263 19.3035 15.6475 21.3623 9.85636 21.8355C7.26983 22.0468 4.95396 21.3745 3.3632 20.6226C2.7415 20.3285 2.70883 19.5053 3.19426 19.0181C4.60477 17.6033 5.04881 16.1954 5.72746 14.0415C5.94546 13.3496 6.18765 12.5805 6.49406 11.7095C7.8214 7.93667 10.8218 4.41024 15.7734 4.93019C15.8627 4.2593 15.8371 3.62393 15.6698 3.10891C15.5419 2.71502 15.7583 2.29151 16.1523 2.16359ZM17.8661 16.4654C17.4825 16.6636 17.0863 16.8303 16.6845 16.9634C15.0668 17.4994 13.289 17.5325 11.8388 16.9634C11.5271 16.8412 11.2438 16.9547 11.1454 17.0962C10.2529 18.3818 9.29889 19.2862 8.13176 19.856C7.81953 20.0084 7.49656 20.133 7.16203 20.2359C7.968 20.3635 8.83431 20.4139 9.73429 20.3404C12.4738 20.1165 14.2543 19.53 15.5634 18.688C16.4479 18.1191 17.179 17.3925 17.8661 16.4654ZM15.4071 6.4009C13.5972 6.25831 12.1734 6.77195 11.0439 7.61672C9.61759 8.6834 8.55903 10.3601 7.9091 12.2075C7.61098 13.055 7.37499 13.8041 7.15617 14.4986L7.13957 14.5513C6.91945 15.2498 6.70851 15.9179 6.47355 16.5376C6.12824 17.4484 5.71834 18.2806 5.11125 19.0894C6.04915 19.0174 6.81011 18.8322 7.47355 18.5083C8.05573 18.2241 8.59073 17.8162 9.11906 17.2398C9.11323 17.2174 9.10689 17.1949 9.10148 17.1724C8.81733 15.9865 9.11196 14.5729 9.99699 12.7554C10.653 11.4085 12.32 9.8186 14.4931 10.478C16.5417 11.0999 16.7939 13.7386 16.0068 15.603C16.0753 15.5827 16.1445 15.5622 16.2128 15.5396C17.5498 15.0964 18.7544 14.2361 19.4716 13.02C19.6237 12.1859 19.6915 11.2134 19.5741 10.2564C19.4585 9.31401 19.1766 8.49674 18.7226 7.88039C18.3272 7.34367 17.7603 6.90083 16.9052 6.65676C16.6811 7.33329 16.3836 7.96 16.0458 8.45754C15.8131 8.79995 15.3464 8.8893 15.0038 8.65676C14.6613 8.42412 14.5721 7.95735 14.8046 7.61476C15.0241 7.29149 15.2342 6.87162 15.4071 6.4009ZM14.1445 11.6265C13.4385 11.4123 12.8359 11.5532 12.3144 11.8804C11.7627 12.2266 11.3218 12.7763 11.0761 13.2808C10.5435 14.3744 10.2841 15.2206 10.2177 15.9019C10.8273 15.3671 11.7099 15.3009 12.3876 15.5669C13.0116 15.8118 13.7544 15.9126 14.5351 15.8648V15.8189L14.7021 15.5366C15.1097 14.8471 15.307 13.8791 15.1835 13.0542C15.0637 12.2541 14.6955 11.7937 14.1445 11.6265Z"
                fill="#007DCB"
              />
            </svg>
          </div>
        </div>
        <div class="flex flex-col items-center gap-1">
          <span class="text-[#505760] text-[1.125rem]/[160%]">{{ 'my-forest.lifetimeEarnings' | translate }}</span>
          @if (isCommissionUser() && lifetimeCommissionResource.status() === 'error') {
            <app-resource-load-error
              message="profile.lifetimeEarningsLoadError"
              (retry)="lifetimeCommissionResource.reload()"
            />
          } @else if (isCommissionUser()) {
            <span
              class="text-[#2C3035] text-[1.9375rem]/[160%] font-bold"
              [attr.aria-busy]="lifetimeCommissionResource.isLoading()"
              >{{ lifetimeCommissionDisplay() }}{{ lifetimeCommissionResource.hasValue() ? ' USD' : '' }}</span
            >
          } @else {
            <span class="text-[#2C3035] text-[1.9375rem]/[160%] font-bold"
              >{{ user()?.lifetimeEarnings | thousandsSeparator }} Ganas</span
            >
          }
          @if (!isCommissionUser()) {
            <span class="text-[#505760] text-[1.125rem]/[160%]">
              {{ 'my-forest.+growing' | translate: { amount: currentMonthChangeAmount } }}
            </span>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="mt-4 p-6 card" data-testid="community-growth">
    <h2 class="text-[#505760] text-[1.625rem] font-bold">{{ 'profile.communityGrowth' | translate }}</h2>
    <p class="text-[#737980] text-[1.125rem] mb-4">{{ 'profile.past12months' | translate: { number: 12 } }}</p>
    <div class="chart-wrapper">
      <div class="y-axis-fixed">
        @for (label of yAxisLabels(); track label) {
          <span>{{ label }}</span>
        }
      </div>
      <div class="chart-scroll-area">
        <div class="min-w-[1100px]">
          @if (mainChartDataLoaded()) {
            <apx-chart
              [series]="mainChartOptions().series"
              [chart]="mainChartOptions().chart"
              [stroke]="mainChartOptions().stroke"
              [markers]="mainChartOptions().markers"
              [colors]="mainChartOptions().colors"
              [dataLabels]="mainChartOptions().dataLabels"
              [xaxis]="mainChartOptions().xaxis"
              [yaxis]="mainChartOptions().yaxis"
              [grid]="mainChartOptions().grid"
              [legend]="mainChartOptions().legend"
              [states]="mainChartOptions().states"
            />
          }
        </div>
      </div>
    </div>
    <div class="flex gap-1 items-center w-full my-3 justify-center">
      <div class="size-[0.875rem] bg-[#017F70] rounded-sm"></div>
      <span class="text-[#505760] text-[0.9375rem]">{{ 'profile.communityMembers' | translate }}</span>
    </div>
    <div class="flex flex-col">
      <div class="flex gap-1" data-testid="community-growth-change" [attr.data-direction]="communityGrowthDirection()">
        <span class="text-[#505760] text-[1.125rem]">{{
          communityGrowthLabel() | translate: { count: communityGrowthMagnitude() }
        }}</span>
        @if (communityGrowthDirection() === 'up') {
          <i>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <path
                d="M13.7489 6L21.3027 6.00052L21.403 6.01444L21.5018 6.04205L21.5621 6.0676C21.6413 6.10246 21.7155 6.15315 21.7808 6.21836L21.8215 6.2624L21.865 6.31878L21.9192 6.4089L21.9579 6.49922L21.977 6.5633L21.9906 6.6273L22 6.7215L22.0004 14.2539C22.0004 14.6681 21.6647 15.0039 21.2504 15.0039C20.8708 15.0039 20.557 14.7217 20.5073 14.3557L20.5004 14.2539L20.5 8.559L12.7812 16.2793C12.5149 16.5455 12.0982 16.5698 11.8046 16.3519L11.7205 16.2793L8.75001 13.3089L3.28033 18.7786C2.98744 19.0715 2.51256 19.0715 2.21967 18.7786C1.9534 18.5123 1.9292 18.0957 2.14705 17.8021L2.21967 17.7179L8.21967 11.7179C8.48593 11.4517 8.90259 11.4275 9.1962 11.6453L9.28032 11.7179L12.2508 14.6883L19.438 7.5H13.7489C13.3692 7.5 13.0554 7.21785 13.0058 6.85177L12.9989 6.75C12.9989 6.3703 13.2811 6.05651 13.6472 6.00685L13.7489 6Z"
                fill="#078339"
              />
            </svg>
          </i>
        } @else if (communityGrowthDirection() === 'down') {
          <i>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <path
                d="M13.7489 19.0002L21.3027 18.9997L21.403 18.9858L21.5018 18.9582L21.5621 18.9326C21.6413 18.8978 21.7155 18.8471 21.7808 18.7819L21.8215 18.7378L21.865 18.6814L21.9192 18.5913L21.9579 18.501L21.977 18.4369L21.9906 18.3729L22 18.2787L22.0004 10.7463C22.0004 10.3321 21.6647 9.99633 21.2504 9.99633C20.8708 9.99633 20.557 10.2785 20.5073 10.6446L20.5004 10.7463L20.5 16.4412L12.7812 8.72096C12.5149 8.45469 12.0982 8.43047 11.8046 8.64832L11.7205 8.72094L8.75001 11.6913L3.28033 6.22162C2.98744 5.92873 2.51256 5.92873 2.21967 6.22162C1.9534 6.48789 1.9292 6.90455 2.14705 7.19816L2.21967 7.28228L8.21967 13.2823C8.48593 13.5485 8.90259 13.5728 9.1962 13.3549L9.28032 13.2823L12.2508 10.3119L19.438 17.5002H13.7489C13.3692 17.5002 13.0554 17.7824 13.0058 18.1485L12.9989 18.2502C12.9989 18.6299 13.2811 18.9437 13.6472 18.9934L13.7489 19.0002Z"
                fill="#CB2222"
              />
            </svg>
          </i>
        }
      </div>
      <span class="text-[#737980] text-[0.9375rem]">{{ 'profile.showingTotal' | translate: { number: months } }}</span>
      @if (isCommunityScaleAdjusted()) {
        <span class="text-[#737980] text-[0.9375rem]">{{ 'profile.communityGrowthScale' | translate }}</span>
      }
    </div>
  </div>
</div>
